import React from "react";
import classnames from "classnames";
import { VerticalDotsIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { uuid } from "uuidv4";

import { store } from "../../../../components/VerticalLayout/store";
import {
    setIsAssociateModalOpened,
    store as generalSettingStore,
    setIsValidateShopArchiveOpened,
    setIsLoading,
    setKey,
} from "../store";
import { generalConfigStore, setItemsDisable } from "@store";

import ErrorToast from "@components/Common/ErrorTost";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import {
    apiRequest,
    ArchivedLanguagesFranchise,
    createLanguageItem,
    getArrayOfRows,
} from "../hooks";
import { ShowSuccessToast } from "../ShowSuccessToast";
import { useFetchGlobal } from "../../../../api/hooks";
type CustomSideFilterType = {
    setLocalFilterActive: Function;
    setIsArchivedLanguagesClicked: Function;
    isArchivedLanguagesClicked: boolean;
    shopState: any;
    setShopState: Function;
    modalState: any;
    setModalState: Function;
};

export function CustomSideFilter({
    setLocalFilterActive,
    setIsArchivedLanguagesClicked,
    isArchivedLanguagesClicked,
    shopState,
    setShopState,
    modalState,
    setModalState,
}: CustomSideFilterType) {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { shopID, userID, franchiseID, operatorID } = useSnapshot(store);
    const {
        numberMultiShopActive,
        numberMultiShopArchived,
        archivedLanguageFranchise,
        modify,
        isLoading,
    } = useSnapshot(generalSettingStore);
    const { itemsDisable } = useSnapshot(generalConfigStore);
    const uuidUser = localStorage.getItem("uuidUser");
    async function activeAllLanguage() {
        setIsLoading(true);
        toast.dismiss();
        let arrayOfRows = getArrayOfRows(shopState, t);
        const item = [...JSON.parse(JSON.stringify(itemsDisable))];
        let languageData: any = {};
        let shopIds: any = [];
        for (let el of arrayOfRows) {
            if (!shopIds.includes(el.shopId.toString())) {
                shopIds.push(el.shopId.toString());
                languageData[el.shopId.toString()] = {};
            }
            const id = el.Id;
            Object.assign(languageData[el.shopId.toString()], {
                ...createLanguageItem(el, id, false, false, false, el.shopId),
            });
            if (
                itemsDisable.find(
                    (item: any) => item.id === id && item.shopId === el.shopId
                ) === undefined
            ) {
                item.push({
                    id: el.Id,
                    state: false,
                    shopId: el.shopId,
                });
            }
        }
        let dataLanguage = {
            userId: userID,
            shopId: shopIds,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            isShop: true,
            data: languageData,
            isMultiShop: true,
        };
        try {
            const result: any = await apiRequest(dataLanguage, fetchGlobal);
            if (result.error) {
                throw new Error("error");
            }
            ShowSuccessToast(
                `${t("The language was successfully unarchived")}`
            );
            setIsLoading(false);
            setKey(uuid());
        } catch (e) {
            ErrorToast(`${t("There's an error")}`);
            setIsLoading(false);
        }
        setItemsDisable(item);
        localStorage.setItem("itemsDisable", JSON.stringify(item));
    }

    return (
        <div className="d-flex justify-content-start align-items-center">
            {modify === true ? (
                <>
                    <CustomMainColorButton
                        className={`${classnames(
                            "lan_btn_BTassignLanguage w-100 ml-2",
                            {
                                "not-allowed-icon__clz":
                                    isArchivedLanguagesClicked || isLoading,
                            }
                        )}`}
                        rounded
                        disabled={shopState.isShopSelected ? false : true}
                        variant="primary"
                        onClick={() => {
                            setIsAssociateModalOpened(true);
                            setShopState({
                                ...shopState,
                                shopID: shopID,
                            });
                            setLocalFilterActive(false);
                        }}
                    >
                        {t("Affect language")}
                    </CustomMainColorButton>
                </>
            ) : null}
            <VerticalDotsIcon
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                style={{ cursor: "pointer" }}
                height={25}
                width={25}
                fill="black"
                className="cmn_drp_BTmenu"
            />
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item cmn_btn_BTlistActivated pl-1 "
                    )}
                    onClick={() => {
                        setIsArchivedLanguagesClicked(false);
                    }}
                >
                    {t("Enabled language(s)")}({numberMultiShopActive})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={classnames(
                        "dropdown-item cmn_btn_BTlistArchived pl-1 "
                    )}
                    onClick={() => {
                        setIsArchivedLanguagesClicked(true);
                    }}
                >
                    {t("Archived language(s)")}({numberMultiShopArchived})
                </div>
                <div
                    style={{ cursor: "pointer" }}
                    className={`${classnames(
                        "dropdown-item cmn_btn_BThistory pl-1 ",
                        {
                            "not-allowed-icon__clz":
                                getArrayOfRows(shopState, t).length === 1 ||
                                shopState.selectedRows.length === 0 ||
                                (isArchivedLanguagesClicked &&
                                    getArrayOfRows(
                                        shopState,
                                        t
                                    ).some((element: any) =>
                                        ArchivedLanguagesFranchise(
                                            archivedLanguageFranchise
                                        ).includes(element.Id)
                                    )) ||
                                isLoading,
                        }
                    )}`}
                    onClick={() => {
                        if (
                            shopState.selectedRows.length === 1 &&
                            (shopState.selectedRows[0].subRows === undefined ||
                                shopState.selectedRows[0].subRows.length < 2)
                        ) {
                            ErrorToast(
                                `${t(
                                    "Attention, it is a multiple action. Please select at least two items"
                                )!}`
                            );
                        } else {
                            setModalState({
                                ...modalState,
                                isHistoryModalOpened: !modalState.isHistoryModalOpened,
                            });
                        }
                    }}
                >
                    {t("Historical")}
                </div>
                {modify === true ? (
                    <>
                        <div
                            style={{ cursor: "pointer" }}
                            className={`${classnames(
                                "dropdown-item cmn_btn_BTarchived cmn_btn_BTunarchive pl-1 ",
                                {
                                    "not-allowed-icon__clz":
                                        isLoading ||
                                        getArrayOfRows(shopState, t).length ===
                                            0 ||
                                        shopState.selectedRows.length === 0 ||
                                        (isArchivedLanguagesClicked &&
                                            getArrayOfRows(
                                                shopState,
                                                t
                                            ).some((element: any) =>
                                                ArchivedLanguagesFranchise(
                                                    archivedLanguageFranchise
                                                ).includes(element.Id)
                                            )),
                                }
                            )}`}
                            onClick={() => {
                                setIsLoading(true);
                                if (
                                    (shopState.selectedRows.length === 1 &&
                                        (shopState.selectedRows[0].subRows ===
                                            undefined ||
                                            shopState.selectedRows[0].subRows
                                                .length < 2)) ||
                                    getArrayOfRows(shopState, t).length === 1
                                ) {
                                    ErrorToast(
                                        `${t(
                                            "Attention, it is a multiple action. Please select at least two items"
                                        )!}`
                                    );
                                    setIsLoading(false);
                                } else {
                                    if (isArchivedLanguagesClicked) {
                                        activeAllLanguage();
                                    } else {
                                        setIsValidateShopArchiveOpened(true);
                                        setIsLoading(false);
                                    }
                                }
                            }}
                        >
                            {isArchivedLanguagesClicked
                                ? t("Unarchive")
                                : t("Archive")}
                        </div>
                    </>
                ) : null}
            </div>
        </div>
    );
}
